export default __webpack_public_path__ + "static/media/arrow-down-icon.382a626c.svg";